// FNP-383: include the soft-delete retention metadata fields in the table
// payload so the admin Accounts table can compute "Days Remaining" for
// PENDING_DELETION rows. Fields are absent (null) on ACTIVE/SUSPENDED rows.
export const listAccounts = `
   query ListAccounts($filter: AccountsFilterInput, $limit: Int, $nextToken: String) {
       listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              sub
              username
              email
              accountType
              accountStatus
              customerId
              deletionRequestedAt
              deletionRequestedBy
              scheduledHardDeleteAt
              created
              updated
           }
           nextToken
       }
   }
`;

export const getAccount = `
   query GetAccount($id: ID!) {
       getAccount(id: $id) {
         id
         sub
         username
         email
         accountType
         accountStatus
         customerId
         deletionRequestedAt
         deletionRequestedBy
         scheduledHardDeleteAt
         created
         updated
       }
}`;
